import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.includes.js";
import React from 'react';
import { countriesI18nExpanded, CountryType } from "../../countries";
import { useTranslation } from 'react-i18next';
import { nsform } from "../../../i18n/namespaces";
const countryNamesToSelectItems = countries => Object.entries(countries).map(([alpha2, country]) => ({
  label: country,
  value: alpha2
})).sort((a, b) => a.label.localeCompare(b.label));
const getCountryTypeOptions = (lang, type, enable) => enable ? countryNamesToSelectItems(countriesI18nExpanded.getTypeNames(lang, type)) : [];
const groupsNumber = (...args) => {
  let groups = 0;
  args.forEach(options => {
    if (options.length) groups++;
  });
  return groups;
};
export const useCountryOptions = filter => {
  const {
    officiallyAssigned = true,
    transitionallyReserved = false,
    exceptionallyReserved = false,
    onlyCountries,
    excludeCountries,
    allowGroups = true
  } = filter !== null && filter !== void 0 ? filter : {};
  const {
    i18n,
    t
  } = useTranslation(nsform.common);
  const ccRawFilter = React.useCallback(raw => {
    if (onlyCountries && onlyCountries.length > 0) return onlyCountries.includes(raw.value);else if (excludeCountries && excludeCountries.length > 0) return !excludeCountries.includes(raw.value);else return true;
  }, [onlyCountries, excludeCountries]);
  const options = React.useMemo(() => {
    const options = [];
    const officially = getCountryTypeOptions(i18n.language, CountryType.OFFICIALLY_ASSIGNED, officiallyAssigned).filter(ccRawFilter);
    const transitionally = getCountryTypeOptions(i18n.language, CountryType.TRANSITIONALLY_RESERVED, transitionallyReserved).filter(ccRawFilter);
    const exceptionally = getCountryTypeOptions(i18n.language, CountryType.EXCEPTIONALLY_RESERVED, exceptionallyReserved).filter(ccRawFilter);
    const groups = groupsNumber(officially, transitionally, exceptionally);
    if (allowGroups && groups >= 2) {
      options.push({
        label: t('input.country.officiallyAssigned'),
        options: officially
      }, {
        label: t('input.country.transitionallyReserved'),
        options: transitionally
      }, {
        label: t('input.country.exceptionallyReserved'),
        options: exceptionally
      });
    } else {
      options.push(...officially, ...exceptionally, ...transitionally);
    }
    return options;
  }, [i18n.language, t, officiallyAssigned, transitionallyReserved, exceptionallyReserved, allowGroups, ccRawFilter]);
  return {
    options
  };
};